import { CfxError } from '@cfxdevkit/cdk';

/** Keystore/crypto failures. */
export class CryptoError extends CfxError {}
